// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__WRteFpKq","slackLink":"slack-link__S749tyQ2"};